import React, { Component } from "react";
import { Row, Col, Button } from "react-bootstrap";
import { Link } from "react-router-dom";

import {
  RetailPosModule,
  InventoryModule,
  PurchasesModule,
  OrdersManagementModule,
  DeliveryManagementModule,
  PackagingManagementModule,
  CrmModule,
  HrmModule,
  AccountingModule,
  ReportsModule,
  LeadsManagementModule,
  CouponsManagementModule,
  ECommerceB2CModule,
  ECommerceB2BModule,
  ProductionModule,
  RawMaterialsModule,
  DemoButton,
  ContactSalesButton,
  SuppliersModule,
  QuoteManagementModule,
  MarketingModule,
  SalesOrderModule,
  ProjectsModule,
  DigitalCatalogModule,
} from "./CommonModules";

import CartContext from "./CartContext";

export class Erp extends Component {
  static contextType = CartContext;

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  handleTryNow = () => {
    const {
      userData,
      ShowUserLoginNew,
      SetSelectedProduct,
      prods,
      ProductType,
    } = this.context;

    if (userData.loginStatus !== "active") {
      ShowUserLoginNew(true);
    } else {
      const selected = prods.find((p) => p.productType === ProductType.ERP);
      SetSelectedProduct(selected);
    }
  };

  render() {
    if (this.context.EcSettings.length === 0) {
      return <></>;
    }

    const base = this.context.GetEcSettingValueByName("StorageBlobImageUrl");

    return (
      <>
        {/* Hero / Marketing Section */}
        <section className="hero container-fluid py-5 bg-white" id="posSection">
          <div className="container">
            <div className="row align-items-center gy-4">
              <div className="col-lg-7">
                <span className="badge-sub">Modern ERP • End-to-end</span>
                <h1 className="display-5 fw-bold mt-3">
                  Modern ERP that connects your entire business — from
                  procurement to production, warehouses to customers.
                </h1>
                <p className="lead text-muted mb-4">
                  One integrated platform for inventory, manufacturing, finance,
                  CRM and field service — built to cut costs, speed fulfillment
                  and scale with your growth.
                </p>

                <p className="mb-4">
                  <strong>Why choose ElasticCART?</strong>
                </p>

                <div className="row g-3">
                  <div className="col-sm-6">
                    <div className="d-flex gap-3 align-items-start">
                      <div className="feature-icon">
                        <i className="fa-solid fa-eye" />
                      </div>
                      <div>
                        <h6 className="mb-1">End-to-end visibility</h6>
                        <small className="text-muted">
                          Real-time dashboards across inventory, orders and
                          finances.
                        </small>
                      </div>
                    </div>
                  </div>

                  <div className="col-sm-6">
                    <div className="d-flex gap-3 align-items-start">
                      <div className="feature-icon">
                        <i className="fa-solid fa-cogs" />
                      </div>
                      <div>
                        <h6 className="mb-1">Operational efficiency</h6>
                        <small className="text-muted">
                          Automated procurement, production scheduling and
                          warehouse workflows.
                        </small>
                      </div>
                    </div>
                  </div>

                  <div className="col-sm-6">
                    <div className="d-flex gap-3 align-items-start">
                      <div className="feature-icon">
                        <i className="fa-solid fa-users" />
                      </div>
                      <div>
                        <h6 className="mb-1">Customer-first growth</h6>
                        <small className="text-muted">
                          Built-in CRM and distribution tools to speed
                          order-to-cash.
                        </small>
                      </div>
                    </div>
                  </div>

                  <div className="col-sm-6">
                    <div className="d-flex gap-3 align-items-start">
                      <div className="feature-icon">
                        <i className="fa-solid fa-chart-line" />
                      </div>
                      <div>
                        <h6 className="mb-1">Scalable & secure</h6>
                        <small className="text-muted">
                          Role-based access, audit trails and multi-location
                          support.
                        </small>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="mt-4">
                  {/* <Button
                    variant="light"
                    size="lg"
                    as={Link}
                    to="#demo"
                    className="me-2"
                    onClick={() =>
                      this.context.HandleTryNowButtonClick(
                        this.context.ProductType.ERP
                      )
                    }
                  >
                    <i className="fa-solid fa-play me-2" /> Book a demo +91
                    9880582728
                  </Button> */}
                  <Row>
                    <Col>
                      <DemoButton></DemoButton>
                    </Col>
                    <Col>
                      <Button
                        variant="primary"
                        size="lg"
                        as={Link}
                        className="my-4"
                        to="/Checkout"
                        onClick={(e) =>
                          this.context.HandleTryNowButtonClick(
                            this.context.ProductType.ERP
                          )
                        }
                      >
                        <i className="fa-solid fa-flask me-2" /> Start free
                        trial
                      </Button>
                    </Col>
                  </Row>
                </div>
              </div>

              <div className="col-lg-5">
                <div className="card card-feature p-4">
                  <div className="card-body">
                    <h5 className="card-title mb-3">Key capabilities</h5>
                    <div className="row">
                      <div className="col-6 mb-3">
                        <i className="fa-solid fa-truck-fast fa-lg me-2" />
                        <strong>Procurement</strong>
                        <div className="text-muted small">
                          Supplier onboarding & purchase orders
                        </div>
                      </div>
                      <div className="col-6 mb-3">
                        <i className="fa-solid fa-boxes-stacked fa-lg me-2" />
                        <strong>Inventory</strong>
                        <div className="text-muted small">
                          Raw materials & finished goods tracking
                        </div>
                      </div>
                      <div className="col-6 mb-3">
                        <i className="fa-solid fa-industry fa-lg me-2" />
                        <strong>Production</strong>
                        <div className="text-muted small">
                          BOMs, scheduling & shop-floor execution
                        </div>
                      </div>
                      <div className="col-6 mb-3">
                        <i className="fa-solid fa-warehouse fa-lg me-2" />
                        <strong>Warehouse</strong>
                        <div className="text-muted small">
                          Receiving, picking & stock control
                        </div>
                      </div>
                      <div className="col-6 mb-3">
                        <i className="fa-solid fa-handshake-angle fa-lg me-2" />
                        <strong>Sales & Distribution</strong>
                        <div className="text-muted small">
                          Channel & order fulfillment
                        </div>
                      </div>
                      <div className="col-6 mb-3">
                        <i className="fa-solid fa-file-invoice-dollar fa-lg me-2" />
                        <strong>Finance</strong>
                        <div className="text-muted small">
                          GL, AR/AP, invoicing & reports
                        </div>
                      </div>
                      <div className="col-6 mb-3">
                        <i className="fa-solid fa-people-roof fa-lg me-2" />
                        <strong>CRM</strong>
                        <div className="text-muted small">
                          Leads, pipeline & support
                        </div>
                      </div>
                      <div className="col-6 mb-3">
                        <i className="fa-solid fa-tools fa-lg me-2" />
                        <strong>Service</strong>
                        <div className="text-muted small">
                          Field service & ticketing
                        </div>
                      </div>
                    </div>

                    <div className="mt-3">
                      {/* <Button
                        variant="primary"
                        size="sm"
                        as={Link}
                        to="#features"
                      >
                        See full feature list
                      </Button> */}
                      {/* <Button
                        variant="outline-secondary"
                        size="sm"
                        as={Link}
                        to="#contact"
                        className="ms-2"
                      >
                        Contact sales +91-9880582728
                      </Button> */}
                      {/* <ContactSalesButton></ContactSalesButton> */}
                    </div>
                  </div>
                </div>
              </div>

              {/* Product overview text */}
              <div className="col-12 mt-4">
                <div>
                  We are a leading provider of ERP solutions for Enterprise
                  Businesses, offering a comprehensive suite of modules to
                  streamline your business workflows. Our ERP modules are
                  designed to be <strong>easy to use</strong> and{" "}
                  <strong>affordable</strong>.
                  <br /> Our approach covers Product Procurement, Production to
                  Sales (Online/Offline) and Delivery.
                </div>
              </div>

              {/* Demo Video */}
              <div className="col-lg-12 mb-lg-5 py-5">
                <img
                  className="w-100"
                  src={base + "carousel2.png"}
                  loading="lazy"
                />
                {/* <video
                  controls
                  height="400px"
                  autoPlay
                  muted
                  loop
                  width="100%"
                  aria-label="ERP demo video"
                >
                  <source
                    src={base + "ManufacturingErpVideo.mp4"}
                    type="video/mp4"
                  />
                  Your browser does not support the video tag.
                </video> */}
              </div>
            </div>

            {/* Modules short list */}
            <div className="row mt-5 modules">
              <div className="col-lg-8">
                <div className="card border-0 shadow-sm">
                  <div className="card-body">
                    <h4 className="mb-3">What we cover</h4>
                    <div className="row g-3">
                      <div className="col-md-6">
                        <ul className="list-unstyled">
                          <li>
                            <strong>Suppliers & Procurement:</strong> vendor
                            onboarding, POs, approvals.
                          </li>
                          <li>
                            <strong>Raw Materials & BOM:</strong> inventory
                            planning and component tracking.
                          </li>
                          <li>
                            <strong>Production:</strong> scheduling, work orders
                            and quality checks.
                          </li>
                          <li>
                            <strong>Finished Goods:</strong> SKU management and
                            release to warehouse.
                          </li>
                        </ul>
                      </div>
                      <div className="col-md-6">
                        <ul className="list-unstyled">
                          <li>
                            <strong>Warehouse:</strong> receiving, putaway,
                            picking & location control.
                          </li>
                          <li>
                            <strong>Distribution & Retail:</strong> channel
                            management and B2B/B2C portals.
                          </li>
                          <li>
                            <strong>CRM & Sales:</strong> pipelines, campaigns
                            and order-to-cash.
                          </li>
                          <li>
                            <strong>Finance & Projects:</strong> GL, AR/AP,
                            invoicing and project budgets.
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-lg-4">
                <div className="cta-strip text-center p-4 rounded">
                  <h5 className="mb-2">Ready to streamline operations?</h5>
                  <p className="mb-3 small text-muted">
                    Book a personalized demo and see how ElasticCART can lower
                    costs and accelerate fulfillment.
                  </p>
                  {/* <Button
                    variant="light"
                    size="sm"
                    as={Link}
                    to="#demo"
                    onClick={() =>
                      this.context.HandleTryNowButtonClick(
                        this.context.ProductType.ERP
                      )
                    }
                  >
                    <i className="fa-solid fa-calendar-check me-2" /> Book a
                    demo
                  </Button> */}
                  <Button
                    variant="primary"
                    size="sm"
                    className="ms-2"
                    as={Link}
                    to="/Checkout"
                    onClick={(e) =>
                      this.context.HandleTryNowButtonClick(
                        this.context.ProductType.ERP
                      )
                    }
                  >
                    <i className="fa-regular fa-clock me-2" /> Start free trial
                  </Button>
                </div>

                <div className="card mt-3 border-0">
                  <div className="card-body small text-muted">
                    <strong>Trusted by:</strong>
                    <div className="mt-2 d-flex gap-2 flex-wrap">
                      <span className="badge bg-light text-dark">Retail</span>
                      <span className="badge bg-light text-dark">
                        Manufacturing
                      </span>
                      <span className="badge bg-light text-dark">
                        Food & Beverage
                      </span>
                      <span className="badge bg-light text-dark">Services</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Footer CTA */}
            <div className="row mt-5">
              <div className="col-12 text-center">
                <p className="text-muted small mb-2">
                  See ElasticCART in action — 30-minute demo, no obligation.
                </p>
                {/* <Button
                  variant="outline-primary"
                  size="lg"
                  className="me-2"
                  onClick={() =>
                    this.context.HandleTryNowButtonClick(
                      this.context.ProductType.ERP
                    )
                  }
                >
                  Book a demo +91-98805 82728
                </Button>
                <Button variant="primary" size="lg" as={Link} to="#contact">
                  Contact sales
                </Button> */}
                <DemoButton></DemoButton>
              </div>
            </div>
          </div>
        </section>

        {/* ERP Modules Section */}
        <section className="container my-5">
          <h5 className="display-6 text-dark mb-4 border-start border-5 border-primary ps-3 py-5">
            Explore Integrated ERP Modules That Power Your Business
          </h5>
          <Row className="g-3">
            {[
              RawMaterialsModule,
              SuppliersModule,
              PurchasesModule,
              ProductionModule,
              InventoryModule,
              MarketingModule,
              DigitalCatalogModule,
              LeadsManagementModule,
              QuoteManagementModule,
              SalesOrderModule,
              RetailPosModule,
              ECommerceB2CModule,
              ECommerceB2BModule,
              OrdersManagementModule,
              PackagingManagementModule,
              DeliveryManagementModule,
              CrmModule,
              CouponsManagementModule,
              AccountingModule,
              HrmModule,
              ProjectsModule,
              ReportsModule,
            ].map((Module, index) => (
              <Col md={6} lg={6} key={index}>
                <div className="bg-light p-3 rounded shadow-sm h-100 hover-shadow">
                  <Module />
                </div>
              </Col>
            ))}
          </Row>
        </section>
      </>
    );
  }
}

// Reusable FeatureSection remains available if you want to reuse elsewhere
const FeatureSection = ({ title, items }) => (
  <div className="mb-4">
    <Row>
      {items.map((item, idx) => (
        <Col md={6} key={idx}>
          <li className="mb-2">{item}</li>
        </Col>
      ))}
    </Row>
  </div>
);

export default Erp;
